import { z } from 'zod'
import { eventDataSchema } from '../../common.schema'

export const UpdateRecipientSchema = z.object({
  event: z.literal('update_recipient'),
  event_data: eventDataSchema,
})

export type UpdateRecipientEvent = z.infer<typeof UpdateRecipientSchema>
